import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import ProjectDetail from "@/pages/ProjectDetail";
import StyleGuide from "@/pages/StyleGuide";
import AdminEmail from "@/pages/AdminEmail";
import SimulationStudios from "@/pages/SimulationStudios";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Montage from "@/pages/Montage";
import MontageEditor from "@/pages/MontageEditor";
import Music from "@/pages/Music";
import Create from "@/pages/Create";
import ScenesBoard from "@/pages/ScenesBoard";
import DirectProjectPage from "@/pages/DirectProject";
import PrivacyPage from "@/pages/Privacy";
import Tutorial from "@/pages/Tutorial";
import Billing from "@/pages/Billing";
import TermsPage from "@/pages/Terms";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import { useRobotsMeta } from "@/hooks/useRobotsMeta";

function AppRouter() {
  const location = useLocation();
  useRobotsMeta();
  // Process the OAuth fragment FIRST (synchronously, before ProtectedRoute runs).
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/tutorial" element={<Tutorial />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/create" element={<Create />} />
      <Route path="/billing" element={<Billing />} />
      <Route
        path="/direct/:id"
        element={
          <ProtectedRoute>
            <DirectProjectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:id/scenes"
        element={
          <ProtectedRoute>
            <ScenesBoard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:id"
        element={
          <ProtectedRoute>
            <ProjectDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/simulation-studios"
        element={
          <ProtectedRoute>
            <SimulationStudios />
          </ProtectedRoute>
        }
      />
      <Route path="/montage" element={<Montage />} />
      <Route path="/music" element={<Music />} />
      {/* Corrector removed from the UX: old links land safely on Montage (backend left dormant). */}
      <Route path="/montage/corrector" element={<Navigate to="/montage" replace />} />
      <Route path="/montage/corrector/:jobId" element={<Navigate to="/montage" replace />} />
      <Route
        path="/admin/email"
        element={
          <ProtectedRoute>
            <AdminEmail />
          </ProtectedRoute>
        }
      />
      {/* Legacy app access key removed: old links land on the dashboard. */}
      <Route path="/access-key" element={<Navigate to="/dashboard" replace />} />
      <Route
        path="/montage/:id"
        element={
          <ProtectedRoute>
            <MontageEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/style-guide"
        element={
          <ProtectedRoute>
            <StyleGuide />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <ErrorBoundary>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
